module.exports = __webpack_public_path__ + "static/img/introduce_5.95d6232.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/hlw/popup/introduce_5.png
// module id = fxtP
// module chunks = 1